import { render, staticRenderFns } from "./NoticesPage.vue?vue&type=template&id=a0a69ad8&scoped=true"
import script from "./NoticesPage.vue?vue&type=script&lang=js"
export * from "./NoticesPage.vue?vue&type=script&lang=js"
import style0 from "./NoticesPage.vue?vue&type=style&index=0&id=a0a69ad8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a69ad8",
  null
  
)

export default component.exports